import React from 'react';

const ContentCard = ({ content }) => {
  return (
    <section className="prompt-template-detail__card prompt-template-detail__card--content">
      <header className="prompt-template-detail__card-header">
        <div>
          <h2 className="prompt-template-detail__card-title">Prompt Content</h2>
          <p className="prompt-template-detail__card-subtitle">
            The full set of instructions used when invoking this template.
          </p>
        </div>
      </header>

      <pre className="prompt-template-detail__content-block">
        {content || 'No content available.'}
      </pre>
    </section>
  );
};

export default ContentCard;

